import { Outlet } from "react-router-dom";
import Layout from "../../layout/Layout";

const Reservation = () => {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
};

export default Reservation;
